// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2dSTD","productName":"Table_productName__HLHgy"};